<template>
  <BaseLayout>
    <div class="row justify-content-center">
      <div class="col-xl-8 col-lg-10">
        <div class="card">
          <div class="card-body p-6">
            <div class="text-center mb-6">
              <div class="mb-4">
                <i :class="hasError ? 'ti ti-alert-circle text-danger' : 'ti ti-credit-card text-primary'" style="font-size: 4rem;"></i>
              </div>
              <h3 class="mb-3" v-if="hasError">Ваш тариф истек</h3>
              <h3 class="mb-3" v-else>Оплата и смена тарифа</h3>
              <p class="text-muted fs-5 mb-0" v-if="hasError">
                Для продолжения работы с функционалом нужно продлить тариф. Обратитесь к персональному менеджеру (если вам назначен) или напишите в поддержку
              </p>
              <p class="text-muted fs-5 mb-0" v-else>
                Для продления, оплаты или смены тарифа обратитесь к персональному менеджеру (если вам назначен) или напишите в поддержку
              </p>
            </div>

            <div class="row g-4 mt-4">
              <div class="col-md-6">
                <div class="card border-primary">
                  <div class="card-body text-center p-5">
                    <div class="mb-3">
                      <i class="ti ti-user text-primary" style="font-size: 3rem;"></i>
                    </div>
                    <h5 class="mb-3">Персональный менеджер</h5>
                    <p class="text-muted mb-4">
                      Если вам назначен персональный менеджер, свяжитесь с ним для получения индивидуального предложения, консультации по тарифам, смены или продления тарифа
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="card border-success">
                  <div class="card-body text-center p-5">
                    <div class="mb-3">
                      <i class="ti ti-headset text-success" style="font-size: 3rem;"></i>
                    </div>
                    <h5 class="mb-3">Служба поддержки</h5>
                    <p class="text-muted mb-4">
                      Напишите в поддержку, и мы поможем вам с оплатой, продлением или сменой тарифа и ответим на все вопросы
                    </p>
                    <button
                      v-if="isJivoEnabled"
                      type="button"
                      class="btn btn-success"
                      @click="openSupport"
                    >
                      <i class="ti ti-headset me-2"></i>
                      Написать в поддержку
                    </button>
                    <p v-else class="text-muted small mb-0">
                      Служба поддержки не настроена
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="mt-6 text-center">
              <router-link to="/settings" class="btn btn-outline-secondary">
                <i class="ti ti-arrow-left me-2"></i>
                Вернуться в настройки
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from "@/layouts/Base.vue";
import {PageInfo} from "@/data/page";
import {user} from "@/data/user";
import {isJivoEnabled, openJivoChat} from "@/utils/jivo";

export default {
  name: 'PaymentView',
  components: {BaseLayout},
  computed: {
    isJivoEnabled() {
      return isJivoEnabled()
    },
    hasError() {
      return this.$route.query.error === 'expired'
    }
  },
  methods: {
    openSupport() {
      openJivoChat()
    },
    setPageInfo() {
      PageInfo.title = 'Оплата и смена тарифа'
      PageInfo.breadcrumbs = [
        {
          title: 'Главная',
          link: '/'
        },
        {
          title: 'Настройки',
          link: '/settings'
        },
        {
          title: PageInfo.title
        }
      ]
    }
  },
  async mounted() {
    this.setPageInfo()
    await user.getUserBase()
  }
}
</script>

<style scoped>
.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
</style>

